import React from 'react';
import { ModalHeader } from 'reactstrap';
import './WizardModalHeader.scss';

const WizardModalHeader = ({ toggle, title, stepLabel }) => (
    <ModalHeader toggle={toggle} className="WizardModalHeader">
        <div className="wizard-modal-header__row">
            <span className="wizard-modal-header__title text-truncate">{title}</span>
            {stepLabel ? (
                <span className="wizard-modal-header__step">{stepLabel}</span>
            ) : null}
        </div>
    </ModalHeader>
);

export default WizardModalHeader;
